import React from 'react';
import moment from 'moment';

const ReportHistoriesTable = ({
  histories = [],
}) => {

  return (
    <React.Fragment>
      <div className='Table Table--user-logs-1'>
        <div className='Table__row'>
          <div className='Table__col Table__col--th'>Date</div>
          <div className='Table__col Table__col--th'>Source</div>
          <div className='Table__col Table__col--th'>Total Report</div>
          <div className='Table__col Table__col--th'>Description</div>
        </div>

        {histories.map((history) => (
          <div key={history.id} className='Table__row'>
            <div className='Table__col'>{moment(history.createdAt).format('YYYY-MM-DD HH:mm')}</div>
            <div className='Table__col'>{history.source}</div>
            <div className='Table__col'>{history.totalReportedCount}</div>
            <div className='Table__col'>{history.description}</div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default ReportHistoriesTable
